import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class EnsureAuthenticated implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const token = sessionStorage.getItem('bbx-token');

    if (token) {
      // Token is present, allow navigation
      return true;
    } else {
      // Check for 'code' in the query parameters
      const code = route.queryParams.code;

      if (code) {
        sessionStorage.setItem('cacheActive', 'false');

        try {
          const tokenResponse = await this.authService.getAccessTokenWithCode(code).toPromise();
          await this.authService.saveLoginInformation(tokenResponse);
          await this.authService.userLoggedInfo(true);
          await this.getCustomerCacheStatus();
          return true;
        } catch (error) {
          // Handle error, navigate to login or show a message
          this.router.navigateByUrl('/');
          return false;
        }
      } else {
        // If 'code' is not present, navigate to the home page and return false
        this.router.navigateByUrl('/');
        return false;
      }
    }
  }

  // Ensure this method returns a Promise or Observable
  getCustomerCacheStatus() {
    const selectedCustomerID = sessionStorage.getItem('bbx-customerID');
    this.authService.getCustomersByCacheStatus(selectedCustomerID).subscribe(res => {
      sessionStorage.setItem('cacheActive', res.cacheActive);
      this.router.navigateByUrl('/shipment-list').then();
    });
  }
}
